import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const COST_RECEIVER_TYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CostReceiverType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const COST_RECEIVER_TYPE_CONFIG = {
  entityName: 'CostReceiverType',
  localizationKey: 'Controlling::Entity.CostReceiverType',
  fields: COST_RECEIVER_TYPE_FIELDS,
  permission: 'ControllingLiquidations.CostReceiverTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
